<script>
  import MenuMixin from "./MenuMixin";

  export default {
    name: "CoachDashboard",
    data() {
      return {
      };
    },
    mixins: [MenuMixin],
    mounted() {
      let menu = this.getMainMenu(this.$mq).filter(item => {
        if (item.path == "coach-dashboard") {
          return item;
        }
      });
      if (menu.length) {
        let submenu = menu[0].items.filter(item => {
          if (item.restricted) {
            return item.access.call();
          } else {
            return true;
          }
        });
        window.location.href = submenu[0].path;
      }
    }
  };
</script>
